import { ICorporatePartCostListItem } from 'corporate/types';

export interface IFlatCostRow {
  _record: ICorporatePartCostListItem;
  cost?: number;
  createdAt: string;
  endDate?: string;
  id: string;
  itemId?: number;
  maxQuantity?: number;
  minQuantity?: number;
  recordId: number;
  startDate: string;
  status: string;
  uom: string;
  userFirstName: string;
  userLastName: string;
}

export const flattenCostRecords = (records?: ICorporatePartCostListItem[]): IFlatCostRow[] => {
  if (!records?.length) {
    return [];
  }

  return records.flatMap((record) => {
    const parentFields = {
      _record: record,
      createdAt: record.createdAt,
      endDate: record.endDate,
      recordId: record.id,
      startDate: record.startDate,
      status: record.status,
      uom: record.uom,
      userFirstName: record.userFirstName,
      userLastName: record.userLastName,
    };

    // Emit a synthetic placeholder leaf so a record with no costItems still
    // renders (and keeps its edit/remove path) instead of vanishing from the table.
    if (!record.costItems?.length) {
      return [{ ...parentFields, id: `${record.id}-empty` }];
    }

    return record.costItems.map((item) => ({
      ...parentFields,
      cost: item.cost,
      id: `${record.id}-${item.id ?? 'leaf'}`,
      itemId: item.id,
      maxQuantity: item.maxQuantity,
      minQuantity: item.minQuantity,
    }));
  });
};
